/**
 * Sends the result of the mobile stepper to the device
 *
 * @param {string} result The result of stepper either 'success' or 'cancelled'.
 */
export const sendToMobileInterface = (result, params = {}) => {
  const data = JSON.stringify({ result, params });

  // For Xamarin mobile app
  if (window?.invokeCSharpAction) {
    window.invokeCSharpAction(data);
  }

  // For flutter mobile app
  if (window?.invokeFlutterAction) {
    window.invokeFlutterAction.postMessage(data);
  }
};
